import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const h1: CSSProperties = {
  fontSize: '56px',
  lineHeight: '60px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const h2: CSSProperties = {
  fontSize: '38px',
  lineHeight: '40px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const h3: CSSProperties = {
  fontSize: '28px',
  lineHeight: '32px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const h4: CSSProperties = {
  fontSize: '24px',
  lineHeight: '28px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const h5: CSSProperties = {
  fontSize: '20px',
  lineHeight: '24px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const h6: CSSProperties = {
  fontSize: '18px',
  lineHeight: '24px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const h7: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};
export const h8: CSSProperties = {
  fontSize: '13px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Regular',
  letterSpacing: 'normal',
};

export const bodyText: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'e-Ukraine-Light',
  letterSpacing: 'normal',
};

export const smallText: CSSProperties = {
  fontSize: '13px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Light',
  letterSpacing: 'normal',
};

export const tinyText: CSSProperties = {
  fontSize: '12px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Light',
  letterSpacing: 'normal',
};

export const labels: CSSProperties = {
  fontSize: '11px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Regular',
  textTransform: 'uppercase',
  letterSpacing: 'normal',
};

export const siteNames: CSSProperties = {
  fontSize: '12px',
  lineHeight: '16px',
  fontFamily: 'e-Ukraine-Head',
  letterSpacing: 'normal',
};

export const siteNamesMedium: CSSProperties = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'e-Ukraine-Head',
  letterSpacing: 'normal',
};

export const monospace: CSSProperties = {
  fontFamily: 'RobotoMono-Regular',
};

/**
  @deprecated please choose h7 or another one
*/
export const subtitle1 = {
  fontSize: '16px',
  lineHeight: '24px',
};

/**
  @deprecated please choose bodyText or another one
*/
export const body1 = { // Body text
  fontSize: '16px',
  lineHeight: '24px',
};

/**
  @deprecated please choose smallText or another one
*/
export const body2 = { // Small text
  fontSize: '13px',
  lineHeight: '18px',
};
/**
  @deprecated please choose tinyText or another one
*/
export const caption = { // Tiny text
  fontSize: '12px',
  lineHeight: '16px',
};
